module.exports = __webpack_public_path__ + "img/observe.b40d0044.svg";